import { useStore } from '../../../app/stores/store';
import { Icon, Menu, Segment } from 'semantic-ui-react';
import { inventoryL2Options } from '../../../app/common/options/dashboardOptions/stepInventoryOptions';
import StepL3ForInventory from './StepL3ForInventory';
import { useEffect } from 'react';
import { userLanguage } from '../../../app/common/userLanguageSchema/userLanguage';

function StepL2ForInventory() {
  const { dashboardStore, WorkLevelStore, commonStore, userStore } = useStore();
  const { workLevelRegistryAll, loadWorkLevels } = WorkLevelStore;

  const dsinventory = dashboardStore.dashboard.L2CardValueInventory;
  useEffect(() => {
    if (workLevelRegistryAll.size <= 1) loadWorkLevels();
  }, [workLevelRegistryAll.size, loadWorkLevels]);

  const openL2ForInventoryFunc = (data: string) => {
    dashboardStore.openL2ForInventory(data, '');
  };
  return (
    <Segment>
      <Menu style={{ height: '60px' }} widths={3}>
        {inventoryL2Options?.map((a: any, index: number) =>
          commonStore.filterModeTwo.includes(a.id) ? (
            <></>
          ) : (
            <Menu.Item
              key={index + 'inv'}
              className={
                dashboardStore.dashboard.L2CardValueInventory === a.text
                  ? 'inventorylevel2dark'
                  : 'inventorylevel2light'
              }
              style={{
                borderRight: '1px solid #F0F0F0',
                background: `linear-gradient(90deg, rgba(215,235,242,1) ${
                  a.gradientvalue
                }%, rgba(255,255,255,1)${a.gradientvalue + 10}% )`,
              }}
              onClick={() => openL2ForInventoryFunc(a.text)}
              disabled={
                !commonStore.filterModeZero?.includes(`${a.id}`) ? false : true
              }
            >
              <h4 style={{ marginTop: '18px' }}>
                <Icon size="big" name={a.Icon} />
                {userStore.user?.customerName === 'Lok Sabha' ? 
                    (userLanguage[0].Level1InventoryLokSabha as any)?.[index]?.text[commonStore.language.key] :
                    userStore.user?.customerName === 'Restoration' ?
                      'New Project' :
                      commonStore.hfcCustomerChanges ?
                        (userLanguage[0].Level1InventoryHFC as any)?.[index]?.text[commonStore.language.key] :
                      userStore?.user?.customerName === 'PCPLCRM' && userStore.user.roleName.trim() === 'CRM' && a.text === 'Receiving' ? 'MIS Register' : 
                        (userLanguage[0].Level1Inventory as any)?.[index]?.text[commonStore.language.key]
                  }
              </h4>
              <Icon />
            </Menu.Item>
          ),
        )}
      </Menu>

      {dsinventory === 'Receiving' ? (
        <StepL3ForInventory
          options={
            userStore.user?.customerName === 'Lok Sabha'
              ? userLanguage[0].Level2InventoryRecievingLokSabha
              : userStore.user?.customerName === 'Restoration'
                ? userLanguage[0].Level2InventoryReceivingRestoration
                : commonStore.hfcCustomerChanges ? userLanguage[0].Level2InventoryRecievingHFC
                : userLanguage[0].Level2InventoryRecieving
          }
          L2Labels={dsinventory}
        />
      ) : dsinventory === 'Delivery' ? (
        <StepL3ForInventory
          options={!commonStore.hfcCustomerChanges ? userLanguage[0].Level2InventoryDelivery : []}
          L2Labels={dsinventory}
        />
      ) : dsinventory === 'Reports' ? (
        <StepL3ForInventory
          options={userLanguage[0].Level2InventoryReports}
          L2Labels={dsinventory}
        />
      ) : null}
    </Segment>
  );
}

export default StepL2ForInventory;
